// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_b-1";
export var movingGradient = "_b-4";
export var movingGradientBlock = "_b-2";
export var skeleton = "_b-0";
export var skeletonText = "_b-3";